import { Component,Inject, OnInit,ViewChild,AfterViewInit  } from '@angular/core';
import { FormBuilder, FormGroup,Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-add-allowed-gt',
  templateUrl: './add-allowed-gt.component.html',
  styleUrls: ['./add-allowed-gt.component.scss']
})
export class AddAllowedGtComponent implements OnInit {

  adAllowedGtFormGroup:FormGroup;
  submitted:boolean=false;
  cameFrom:any;
  gt:any;
  Type:any;
  constructor(public dialogRef: MatDialogRef<AddAllowedGtComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,private formBuilder: FormBuilder,
    private endpointsService: EndpointsService,
     private backendApiService: BackendApiService,
     private spinnerService:Ng4LoadingSpinnerService,
     private router:Router) { }

  ngOnInit(): void {
    this.cameFrom = this.data.came;
    this.gt = this.data.gt;
    this.Type = this.data.type;
    console.log("oGt",this.gt)
    console.log("cameeeee",this.cameFrom)
    console.log("ttttt",this.Type)
    this.addAllowedGtForm()
  }
  addAllowedGtForm(){
    this.spinnerService.show();
    this.adAllowedGtFormGroup =  this.formBuilder.group({
     
      gt:[this.gt],
     
    })
  }
  get f(){
    return this.adAllowedGtFormGroup.controls;
    
   }
   onClose(){
    this.dialogRef.close();
  }
  addAllowdGT(){
console.log("MMMMM")
  this.backendApiService.callToApi(this.endpointsService.URL_ADD_ECOWAS_ALLOWED_GT +
    '&gt=' + this.adAllowedGtFormGroup .get('gt').value + '&type=' + this.Type
     
  
      )
  .subscribe(response => {
    console.log("responseeee",response)
    if (response === null || response === false ) {
      alert('Not Added');
      return;
    }
    
     else {
      alert('Add successfully');        
      this.spinnerService.show();
      this.dialogRef.close()
      if(this.cameFrom == 'rrms'){
        this.router.navigate(['/service-live-dashboard/rrms-service-live-dashboard'])
        }else{
          this.router.navigate(['/service-live-dashboard/sms-pdp-service-live-dashboard'])
        }
    }
})
  }

}
